import React, { Component } from 'react';

class LandingImage extends Component {

	render() {
		return <div className="col-8 landing-right" />;
	}
}

export default LandingImage;



// WEBPACK FOOTER //
// ./src/components/landing_image.js